export const getAllCatId = (newCatId) => {
  const singlegetNewcatIdPop = newCatId && newCatId.split(',');
  const newSet = new Set(singlegetNewcatIdPop);
  const uniqueCatIdSet = [...newSet];
  uniqueCatIdSet.pop();
  return uniqueCatIdSet.join();
};

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity
export const filterItems = (getAllNewMultiPack, getAllMultiPack, skuInfo, partIdInfo) => {
  let newCatId = '';
  let getpart;
  let isSingleProduct;
  const getAllMultiPackNumber = [];
  for (let index = 0; index < getAllMultiPack.length; index += 1) {
    if (
      (skuInfo.productPartNoOfCurrentColor
        ? getAllMultiPack[index].prodpartno === skuInfo.productPartNoOfCurrentColor
        : getAllMultiPack[index].name.toLowerCase() === skuInfo.color.name.toLowerCase()) &&
      getAllMultiPack[index].TCPMultiPackReferenceUSStore
    ) {
      getAllMultiPackNumber.push(getAllMultiPack[index].TCPMultiPackReferenceUSStore);
    }
  }

  for (let j = 0; j < getAllNewMultiPack.length; j += 1) {
    for (let k = 0; k < getAllNewMultiPack[j].variants.length; k += 1) {
      if (
        getAllMultiPackNumber.length > 0 &&
        skuInfo &&
        getAllNewMultiPack[j].variants[k].v_tcpsize &&
        (skuInfo.size === getAllNewMultiPack[j].variants[k].v_tcpsize.split('_')[1] ||
          skuInfo.size === getAllNewMultiPack[j].variants[k].v_tcpsize) &&
        getAllMultiPackNumber[0].indexOf(`${getAllNewMultiPack[j].prodpartno}#`) > -1
      ) {
        /* eslint-disable camelcase */
        const { v_item_catentry_id } = getAllNewMultiPack[j].variants[k];
        if (getAllMultiPackNumber[j] && partIdInfo[j].split(',').length > 1) {
          getpart = partIdInfo[j].split(',');
        }

        if (getAllMultiPackNumber[0].includes(',')) {
          getpart = getAllMultiPackNumber[0].split(',');
        } else if (getAllNewMultiPack[j].prodpartno === getAllMultiPackNumber[0].split('#')[0]) {
          getpart = getAllMultiPackNumber;
          isSingleProduct = true;
        }
        const results =
          getpart &&
          getpart.find((element) => element.indexOf(getAllNewMultiPack[j].prodpartno) === 0);
        const getNewCatIdVal = `${v_item_catentry_id}_${
          isSingleProduct ? getpart[0].split('#')[1] : results && results.split('#')[1]
        },`;
        if (isSingleProduct) {
          newCatId += getNewCatIdVal;
          return getAllCatId(newCatId);
        }

        newCatId += getNewCatIdVal;
      }
    }
  }
  return getAllCatId(newCatId);
};
